import { PaymentDetail } from "./PaymentDetail"

export class PaymentInformation{
  paymentOrderId: string = ""
    payment_mode: string = ""
    amount: number = 0.0
    pay_bill_amount: number = 0.0
    bill_item_amount: number = 0.0
    subscription_choice: string = ""
    paymentStatus: number = 0
    mobile_money_number: string = ""
    server_invoice_id=0
    server_guardian_id=0
    isGrouping=0
    status=""
    data = new PaymentDetail()

}
